import filterOperators from "@/providers/filterProvider/filterOperators";

const defaultOperator = filterOperators.contains;
export default {
  defaultOperator
};
